var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconYoutube = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "YouTube-White-Silhoutte",
    width: 20,
    height: 14.005,
    viewBox: "0 0 20 14.005",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    d: "M19.588 2.191A2.506 2.506 0 0 0 17.826.43C16.26 0 10 0 10 0S3.74 0 2.175.412A2.557 2.557 0 0 0 .412 2.191 26.414 26.414 0 0 0 0 7a26.314 26.314 0 0 0 .412 4.811 2.507 2.507 0 0 0 1.763 1.763C3.756 14 10 14 10 14s6.26 0 7.825-.412a2.506 2.506 0 0 0 1.763-1.763A26.435 26.435 0 0 0 20 7.018a25.063 25.063 0 0 0-.412-4.827zM8.008 10V4l5.206 3z",
    className: "cls-1",
    "data-name": "Path 2653"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-youtube.9249f07a.svg";
export { ForwardRef as ReactComponent };